"use strict";
/**
 * @module adaptive-expressions
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const expressionEvaluator_1 = require("./expressionEvaluator");
const expressionFunctions_1 = require("./expressionFunctions");
/**
 * FunctionTable is a dictionary which merges BuiltinFunctions.Functions with a CustomDictionary.
 */
class FunctionTable {
    constructor() {
        this.customFunctions = new Map();
    }
    keys() {
        const keysOfAllFunctions = Array.from(expressionFunctions_1.ExpressionFunctions.standardFunctions.keys()).concat(Array.from(this.customFunctions.keys()));
        return keysOfAllFunctions[Symbol.iterator]();
    }
    values() {
        const valuesOfAllFunctions = Array.from(expressionFunctions_1.ExpressionFunctions.standardFunctions.values()).concat(Array.from(this.customFunctions.values()));
        return valuesOfAllFunctions[Symbol.iterator]();
    }
    get size() {
        return expressionFunctions_1.ExpressionFunctions.standardFunctions.size + this.customFunctions.size;
    }
    get isReadOnly() {
        return false;
    }
    get(key) {
        if (expressionFunctions_1.ExpressionFunctions.standardFunctions.get(key)) {
            return expressionFunctions_1.ExpressionFunctions.standardFunctions.get(key);
        }
        if (this.customFunctions.get(key)) {
            return this.customFunctions.get(key);
        }
        return undefined;
    }
    set(key, value) {
        if (expressionFunctions_1.ExpressionFunctions.standardFunctions.get(key)) {
            throw Error(`You can't overwrite a built in function.`);
        }
        this.customFunctions.set(key, value);
        return this;
    }
    add(param1, param2) {
        if (arguments.length === 1) {
            if (param1 instanceof Object) {
                this.set(param1.key, param1.value);
            }
        }
        else {
            if (typeof param1 === 'string') {
                if (param2 instanceof expressionEvaluator_1.ExpressionEvaluator) {
                    this.set(param1, param2);
                }
                else {
                    this.set(param1, new expressionEvaluator_1.ExpressionEvaluator(param1, expressionFunctions_1.ExpressionFunctions.apply(param2)));
                }
            }
        }
    }
    clear() {
        this.customFunctions.clear();
    }
    has(key) {
        return expressionFunctions_1.ExpressionFunctions.standardFunctions.has(key) || this.customFunctions.has(key);
    }
    delete(key) {
        return this.customFunctions.delete(key);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forEach(_callbackfn, thisArg) {
        throw Error(`forEach function not implemented`);
    }
    entries() {
        throw Error(`entries function not implemented`);
    }
    get [Symbol.iterator]() {
        throw Error(`Symbol.iterator function not implemented`);
    }
    get [Symbol.toStringTag]() {
        throw Error(`Symbol.toStringTag function not implemented`);
    }
}
exports.FunctionTable = FunctionTable;
//# sourceMappingURL=functionTable.js.map